export default __webpack_public_path__ + "images/bgflt1.272fcb3.jpg";